module.exports = __webpack_public_path__ + "img/document-redesign.9a3aaa12.svg";